import { render, staticRenderFns } from "./LedgerAggregate.vue?vue&type=template&id=2291726c"
import script from "./LedgerAggregate.vue?vue&type=script&lang=js"
export * from "./LedgerAggregate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports